/**
 * Mixin for generating ItemList JSON-LD schema on PLPs.
 * Reads products from productsSearch store (populated by ListOfProducts slice).
 */
import { sanitizeJsonLdStrings } from "~/utils/jsonld-sanitize";

export default {
  computed: {
    itemListSchemaScript() {
      // Build ItemList schema from store (populated by ListOfProducts slice fetch)
      const products = this.$store.getters["productsSearch/hits"] || [];
      if (products.length < 1) {
        return null;
      }

      const handles = products.map(p => p?.handle).filter(Boolean);
      const base = (this.$config?.appEndPoint || "").replace(/\/$/, "");
      const itemListElement = handles.map((handle, index) => ({
        "@type": "ListItem",
        position: index + 1,
        url: `${base}/products/${encodeURIComponent(handle)}`,
      }));

      const schema = {
        "@context": "https://schema.org",
        "@type": "ItemList",
        itemListElement,
      };

      // Use route-specific identifier for uniqueness
      const identifier = this.uid || this.$route.params.handle || "plp";
      const hid = `jsonld-itemlist-${String(identifier)
        .replace(/\s+/g, "-")
        .toLowerCase()}`;

      return {
        hid,
        type: "application/ld+json",
        innerHTML: JSON.stringify(sanitizeJsonLdStrings(schema)),
      };
    },
  },
};
